import { Body } from '../types.js';
import { computeAccelerations } from './gravity.js';

export function integrateBodies(bodies: Body[], dt: number) {
  // Velocity Verlet integration (symplectic → energy conserving)
  // Step 1: compute current accelerations
  const oldAccels = computeAccelerations(bodies, 1.0);

  // Step 2: update positions
  for (const body of bodies) {
    body.x += body.vx * dt + 0.5 * body.ax * dt * dt;
    body.y += body.vy * dt + 0.5 * body.ay * dt * dt;
  }

  // Step 3: compute new accelerations at new positions
  const newAccels = computeAccelerations(bodies, 1.0);

  // Step 4: update velocities
  for (let i = 0; i < bodies.length; i++) {
    bodies[i].vx += 0.5 * (bodies[i].ax + newAccels[i].ax) * dt;
    bodies[i].vy += 0.5 * (bodies[i].ay + newAccels[i].ay) * dt;
    bodies[i].ax = newAccels[i].ax;
    bodies[i].ay = newAccels[i].ay;
  }
}

export function advanceTrails(bodies: Body[], maxTrailLen: number) {
  for (const body of bodies) {
    body.trail.push({ x: body.x, y: body.y });
    if (body.trail.length > body.maxTrail) {
      body.trail.shift();
    }
  }
}
